import React from 'react';
import * as Yup from 'yup';
import TextInput from '@atoms/TextInput/index';
import { getErrorText, getUrlMatchRegex } from '@general/helpers/forms.helpers';

const errorText = getErrorText('url');
const urlMatch = getUrlMatchRegex();

export const editProfileSocialValidationSchema = {
    twitterUrl: Yup.string().matches(urlMatch, errorText),
    linkedinUrl: Yup.string().matches(urlMatch, errorText),
    blogUrl: Yup.string().matches(urlMatch, errorText),
};

const EditProfileFieldsSocial = () => (
    <>
        <TextInput label="Twitter" name="twitterUrl" type="url" placeholder="e.g. twitter.com/janedoe" />
        <TextInput label="LinkedIn" name="linkedinUrl" type="text" placeholder="e.g. linkedin.com/in/janedoe" />
        <TextInput label="Blog or Personal Site" name="blogUrl" type="text" placeholder="e.g. janedoe.com" />
    </>
);

export default EditProfileFieldsSocial;
